import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Components as ErrorMessageComponents } from './errorMessage.style';
const ErrorMessage = _ref => {
  let {
    errorMessage
  } = _ref;
  return _jsx(_Fragment, {
    children: errorMessage && _jsx(ErrorMessageComponents.Message, {
      children: errorMessage
    })
  });
};
export default ErrorMessage;